import { render, staticRenderFns } from "./ComplaintReports.vue?vue&type=template&id=2c480629&"
import script from "./ComplaintReports.vue?vue&type=script&lang=js&"
export * from "./ComplaintReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports